$(document).ready(function () {
    var recaptchaContainers = $(".g-recaptcha");
    var standardRecaptchaWidth = 304;

    function resizeRecaptchas() {
        recaptchaContainers.each(function () {
            var captcha = $(this);
            var parentWidth = captcha.parent().innerWidth();

            var scale = Math.min(1, parentWidth / standardRecaptchaWidth);

            captcha.css("transform", "scale(" + scale + ")");
        });
    }

    if (recaptchaContainers.length) {
        $(window).on("resize", function () {
            resizeRecaptchas();
        });

        resizeRecaptchas();
    }
}); 
